import { AfterViewInit, Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { JwTokenHandler } from '../shared/services/jw-token-handler.service';
import { UserState } from '../auth/services/user-state.service';

@Directive({
  selector: '[hasPermission]'
})
export class PermissionDirective implements AfterViewInit {

  @Input() action: 'DISABLE' | 'HIDDEN' | 'D-NONE' = 'D-NONE';
  @Input('hasPermission') allowedPermissions: Array<string> = [];

  userPermission: any;

  constructor(
    private elm: ElementRef,
    private renderer: Renderer2,
    private userState: UserState
  ) {
    this.userPermission = userState.claims;
  }

  ngAfterViewInit(): void {
    if(JwTokenHandler.userHasPermission(this.userPermission, this.allowedPermissions))
      return;

    switch(this.action) {
      case 'D-NONE':
        this.dnoneElement();
      case 'HIDDEN':
        this.hideElement();
      case 'DISABLE':
        this.disableElement();
    }

  }

  private hideElement() {
    this.renderer.setStyle(this.elm.nativeElement, 'visibility', 'hidden');
    this.renderer.setStyle(this.elm.nativeElement, 'pointer-events', 'none');
  }

  private dnoneElement() {
    this.renderer.setStyle(this.elm.nativeElement, 'display', 'none');
  }

  private disableElement() {
    this.renderer.setAttribute(this.elm.nativeElement, 'disabled', 'true');
  }

}
